import {Asset} from '../../../modules/Assets/Assets.types';

/**
 * Gets all possible URLs from an asset (original file + all derivatives)
 * Used for matching assets against usedAssetUrls
 */
export default function getAllAssetUrls(asset: Asset): string[] {
  const urls: string[] = [];

  // Add original file URL
  if (asset.originalfile?.fileUrl) {
    urls.push(asset.originalfile.fileUrl);
  }

  // Add all file derivative URLs
  asset.derivedFiles.forEach((file) => {
    urls.push(file.technicalMetadata?.fileUrl || '');
  });

  return urls;
}
